import { HeroSectionType } from "@/components/features/hero";
import { ExtractPropertyType } from "types";
import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function hasProperty<K extends string, V>(
  obj: unknown,
  key: K,
  valueCheck?: (value: unknown) => value is V,
): obj is Record<K, V> {
  if (typeof obj !== "object" || obj === null) {
    return false;
  }

  if (!(key in obj)) {
    return false;
  }

  if (valueCheck) {
    return valueCheck((obj as Record<string, unknown>)[key]);
  }

  return true;
}

export type SanityButtonType = NonNullable<
  ExtractPropertyType<HeroSectionType, "ctas">
>[number];

export const getURL = (button: SanityButtonType) => {
  const link = button.link;

  if (!link) return "coming-soon";

  if ("slug" in link) {
    return link.slug;
  }

  if ("url" in link) return link.url;

  return "coming-soon";
};
